import React from 'react'
import {
    Modal,
    ModalBody,
    Text,
    Box,
    Input,
    Button,
    Notify,
    Grid,
    Select
} from 'flexibull2'
import { TOP_RIGHT, ERROR_ALERT } from '../../utils/constants'

const EditDepartmentFromStore = ({
    open,
    loading,
    current,
    editDepartmentFromStore,
    setOpen,
    faculties,
}) => {
    const [department, setDepartment] = React.useState({
        name: '',
        short_code: '',
    })
    const [faculty, setFaculty] = React.useState(null)
    React.useEffect(() => {
        if (current) {
            const { department_name, short_code, faculty_name } = current
            setDepartment({
                name: department_name,
                short_code,
            })
            setFaculty({
                value: faculty_name,
                label: faculty_name,
            })
        }
    }, [current])
    const { name, short_code } = department

    let Values = []

    faculties &&
        faculties.map((faculty) =>
            Values.push({
                label: faculty.name,
                subText: faculty.short_code
            })
        )
    const handleChange = (e) => {
        const { name, value } = e.target
        setDepartment({ ...department, [name]: value })
    }

    const handleFaculty = (faculty) => {
        setFaculty(faculty)
    }

    const onUpdateDepartment = (e) => {
        e.preventDefault()
        if (name === '' || short_code === '') {
            Notify(`Please fill in all the fields and try again`, {
                position: TOP_RIGHT,
                status: ERROR_ALERT,
            })
        } else {
            const data = {
                department_name: name,
                short_code,
                faculty_name: faculty?.value        
             }

            editDepartmentFromStore(data, current)
            setDepartment({ name: '', short_code: '' })
        }
        setOpen(false)
    }

    const onClose = () => {
        setOpen(false)
    }
    return (
        <div>
            <Modal outerClick open={open}>
                <ModalBody style={{ background: '#fff' }} width="570px">
                    <Box pad="20px 40px 0">
                        <Box margin="20px 0 20px 0">
                            <Text size="22px" block>
                                Edit Department
                            </Text>
                        </Box>
                        <Box margin="20px 0">
                            <Select
                                value={faculty}
                                onChange={handleFaculty}
                                elementOptions={Values}
                                label="Faculty"
                                placeholder="Select Faculty"
                                spaceBottom
                                spaceTop
                                width={260}
                            />
                        </Box>
                        <Grid default="1fr 1fr">
                            <Box margin="0px 0px 25px 0px">
                                <Input
                                    label="Department Title"
                                    name="name"
                                    value={name}
                                    onChange={handleChange}
                                    placeholder="Department Title"
                                    spaceBottom="45px"
                                    width="280px"
                                />
                            </Box>
                            <Box pad=" 0 0 0">
                                <Input
                                    label="Department Short Code"
                                    name="short_code"
                                    value={short_code}
                                    onChange={handleChange}
                                    placeholder="Department Short Code"
                                    width="200px"
                                    spaceBottom="45px"
                                />
                            </Box>
                        </Grid>
                    </Box>
                    <Box pad="0px 30px 40px 0">
                        <Grid default="2fr 1fr 1fr">
                            <Box
                                style={{
                                    marginLeft: '20px',
                                    marginTop: '-10px',
                                }}
                            ></Box>
                            <Box align="right">
                                <Button
                                    style={{
                                        border: 'none',
                                        textAling: 'center',
                                        color: '#000',
                                    }}
                                    width={90}
                                    height={30}
                                    onClick={onClose}
                                    pale
                                    pad="0 20px"
                                >
                                    Cancel
                                </Button>
                            </Box>
                            <Box align="right">
                                <Button
                                    width={120}
                                    height={30}
                                    pad="0 15px"
                                    spaceRight
                                    onClick={onUpdateDepartment}
                                    progress={loading}
                                    disabled={loading}
                                    iconRight={
                                        <i className="flexibull-angle-right" />
                                    }
                                >
                                    {loading ? 'Updating' : 'Update'}
                                </Button>
                            </Box>
                        </Grid>
                    </Box>
                </ModalBody>
            </Modal>
        </div>
    )
}

export default EditDepartmentFromStore
